<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-flex>
        <span class="drawer__title text--ellipsis">
          <span v-if="user && user.name">
            {{ user.name | ellipsis(25) }}
          </span>
          <span v-else>-</span>
        </span>
      </v-flex>

      <v-btn color="gray-6" flat icon class="mx-0" slot="activator" @click="close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    user: {
      type: Object
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
